import { RoomBody, RoomView, NodeBody, NodeView, ChatBody, ChatView } from '@lemoncloud/eureka-chats-api';
import { webCore } from '@lemon/web-core';
const BASE_URL = import.meta.env.VITE_CHAT_API_ENDPOINT;

export const createRoom = async (body: RoomBody) => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BASE_URL}/rooms/0`,
        })
        .setBody(body)
        .execute<RoomView>();

    return data;
};

export const fetchRoom = async (roomId: string) => {
    const { data } = await webCore
        .buildRequest({
            method: 'GET',
            baseURL: `${BASE_URL}/public/room-detail`,
        })
        .setParams({ roomId })
        .execute<RoomView>();

    return data;
};

export const enterRoom = async (body: NodeBody) => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BASE_URL}/public/start-chat`,
        })
        .setBody(body)
        .execute<NodeView>();

    return data;
};

export const sendMessage = async (body: ChatBody) => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BASE_URL}/public/send-message`,
        })
        .setBody(body)
        .execute<ChatView>();

    return data;
};

export const leaveRoom = async (nodeId: string) => {
    const { data } = await webCore
        .buildRequest({
            method: 'POST',
            baseURL: `${BASE_URL}/public/leave-chat`,
        })
        .setBody({})
        .setParams({ nodeId })
        .execute<NodeView>();

    return data;
};

export const updateNode = async (nodeId: string, connectionId: string) => {
    const { data } = await webCore
        .buildRequest({
            method: 'POST',
            baseURL: `${BASE_URL}/public/update-node`,
        })
        .setParams({ nodeId })
        .setBody({ connectionId })
        .execute<NodeView>();

    return data;
};

// cht-d1/public/leave-chat
